module.exports = __webpack_public_path__ + "img/healthProMobile1-EN.2f4e266d.png";